import React, { useRef, useEffect, useState } from 'react';
import Carousel from 'react-multi-carousel';
import usePrice from '../../hooks/usePrice';
import { useTranslation } from 'react-i18next';
import useWindowSize from '../../hooks/useWindowSize';
import SecondLayer from '../Carousels/SecondLayer';
import { IProduct } from '../../models';
import localizedRoute from '../../utils/localizedRoute';
import Link from 'next/link';

const PLACEHOLDER_URL = '/img/placeholder.svg';

const ProductRelated = ({ product }: { product: IProduct | undefined }) => {
  const [hideLayer, setHideLayer] = useState(false);
  const { related = [] } = product || {};
  const [formatPrice] = usePrice();
  const refCarousel = useRef<any>();
  const { t } = useTranslation();
  const [width] = useWindowSize();

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      partialVisibilityGutter: 0
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      partialVisibilityGutter: 20
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      partialVisibilityGutter: 20
    }
  };

  useEffect(() => {
    setLayer();
    setHideLayer(width > 1024 && related && related.length < 4);
  }, [related, width]);

  const setLayer = () => {
    try {
      const ul = document.querySelector('.my-carousel')?.childNodes[0];
      const first = ul?.childNodes[0]?.childNodes[0] as HTMLElement;
      const layer = document.querySelector('#related-layer') as HTMLElement;
      const title = document.querySelector('.related-title') as HTMLElement;
      const image = document.querySelector('.related-image') as HTMLElement;
      if (first && layer) {
        const { marginRight = '' } = getComputedStyle(first);
        layer.style.width = `${first.offsetWidth}px`;
        layer.style.marginLeft = `${
          first.offsetWidth + Number(marginRight.replace('px', ''))
        }px`;
        layer.style.height = `${image.offsetHeight + title.offsetHeight}px`;
      }
    } catch (error) {
      console.log(error);
    }
  };

  if (!related || !Array.isArray(related)) {
    return null;
  }
  return (
    <>
      <h2
        className="text-5xl md:text-40 leading-tight font-sans mb-6 text-black font-bold"
        dangerouslySetInnerHTML={{ __html: t('THIRD_CAROUSEL_TITLE') }}
      />
      <Carousel
        ssr
        ref={refCarousel}
        partialVisible
        responsive={responsive}
        swipeable={true}
        draggable={true}
        showDots={false}
        containerClass="carousel-container my-carousel"
        infinite={true}
        arrows={width < 640}
      >
        {related.map((item, i) => (
          <div className="mr-3" key={i}>
            <div
              className="bg-no-repeat h-96 w-full p-4 rounded-xl related-image"
              style={{
                backgroundImage: `linear-gradient(to bottom, rgba(0, 20, 26, 0.1), rgba(0, 20, 26, 0.25)), url(" ${
                  item.image || PLACEHOLDER_URL
                }")`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            />
            <div className="w-full pt-5 flex flex-col md:flex-row related-title">
              <Link
                href={localizedRoute(item.slug)}
                className="font-bold flex-grow"
              >
                <span aria-hidden="true" className="absolute inset-0" />
                {item.name}
              </Link>
              {item.crossed_price ? (
                <>
                  <span className="line-through	text-gray-400 pl-2">
                    {formatPrice(item.crossed_price)}
                  </span>
                  <span className="font-bold pl-2">
                    {' '}
                    {formatPrice(item.price)}
                  </span>
                </>
              ) : (
                <p className="whitespace-nowrap opacity-60 pl-0 md:pl-5 mt-2 md:mt-0">
                  {formatPrice(item.price)}
                </p>
              )}
            </div>
          </div>
        ))}
      </Carousel>
    </>
  );
};

export default ProductRelated;
